/*
 * NOURION Bedarfscheck, Verhalten der Sektion nourion-bedarfscheck.liquid.
 * Portierung von src/lib/advisor.ts (Empfehlungslogik) und der
 * Zustandsmaschine aus src/components/sections/AdvisorSection.tsx.
 *
 * Die Paket Stammdaten (Name, Taglines) stammen aus src/data.ts
 * PACKAGES, hier als Konstante hinterlegt, weil das Ergebnis Panel
 * komplett von den Live Antworten abhaengt und sich nicht serverseitig
 * vorausberechnen laesst (siehe Kommentar am Kopf der .liquid Datei).
 * Seit dem Umbau auf das reine Anfragemodell (20.08.2026) rechnet der
 * Bedarfscheck KEINE Richtpreise mehr; das Ergebnis ist die
 * Paketempfehlung mit Begruendung, das Angebot folgt nach dem
 * kostenlosen Erstgespraech.
 *
 * Reinitialisiert sich bei shopify:section:load und ist idempotent
 * (data-nbc-init Flag je Wurzelelement).
 */
(function () {
  'use strict';

  // ── Paket Stammdaten (src/data.ts PACKAGES) ──────────────────────────────
  var PACKAGES = {
    m: {
      id: 'm',
      name: 'NOURION Basic',
      sizeLabel: 'für 1 bis 5 Arbeitsplätze',
      tagline: 'Die solide Basis: eingerichtet, gesichert und dauerhaft betreut.'
    },
    l: {
      id: 'l',
      name: 'NOURION Plus',
      sizeLabel: 'für 5 bis 15 Arbeitsplätze',
      tagline: 'Der digitale Arbeitsplatz: Wir übernehmen die volle Verantwortung.'
    },
    xl: {
      id: 'xl',
      name: 'NOURION Enterprise',
      sizeLabel: 'ab 15 Arbeitsplätzen',
      tagline: 'Ausfallsichere IT für größere und verteilte Betriebe.'
    }
  };
  var PACKAGE_ORDER = ['m', 'l', 'xl'];

  // ── Antwortoptionen (src/lib/advisor.ts) ─────────────────────────────────
  var WORK_STYLE_OPTIONS = [
    { value: 'buero', label: 'Vor allem an einem Ort' },
    { value: 'gemischt', label: 'Büro und Homeoffice' },
    { value: 'unterwegs', label: 'Viel unterwegs' }
  ];
  var DATA_OPTIONS = [
    { value: 'normal', label: 'Übliche Geschäftsdaten' },
    { value: 'sensibel', label: 'Besonders geschützte Daten' }
  ];
  var DOWNTIME_OPTIONS = [
    { value: 'verkraftbar', label: 'Ärgerlich, aber verkraftbar' },
    { value: 'teuer', label: 'Das wird schnell teuer' },
    { value: 'kritisch', label: 'Geht gar nicht' }
  ];

  var STEP_LABEL_COUNT = 5; // Team, Arbeitsweise, Daten, Ausfall, Ergebnis

  // Kleine Icons fuer dynamisch erzeugte Listenpunkte im Ergebnis
  var CHECK_SVG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"></path></svg>';
  var PLUS_SVG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg>';

  // ── Empfehlungslogik, aus src/lib/advisor.ts (ohne Preisrechnung) ────────

  function recommendPackage(answers) {
    var seats = answers.seats;
    var workStyle = answers.workStyle;
    var dataSensitivity = answers.dataSensitivity;
    var downtimeImpact = answers.downtimeImpact;

    // 1) Groesse nach Arbeitsplaetzen
    var packageId = seats <= 5 ? 'm' : seats <= 15 ? 'l' : 'xl';

    // 2) M reicht nicht, wenn Geraete unterwegs sind, Daten besonders
    //    geschuetzt sind oder ein Ausfall richtig weh tut
    var needsL =
      dataSensitivity === 'sensibel'
      || downtimeImpact === 'teuer'
      || downtimeImpact === 'kritisch'
      || workStyle === 'gemischt'
      || workStyle === 'unterwegs';
    if (packageId === 'm' && needsL) packageId = 'l';

    // 3) Begruendungen, jede zutreffende Zeile einmal
    var reasons = [];
    if (packageId === 'm') {
      reasons.push(
        'Mit ' + seats + ' ' + (seats === 1 ? 'Arbeitsplatz' : 'Arbeitsplätzen') +
        ', fester Arbeit im Büro und überschaubarem Risiko reicht die solide Basis, mehr würden wir Ihnen ehrlicherweise nicht verkaufen.'
      );
    }
    if (packageId === 'l' && seats <= 5 && needsL) {
      reasons.push(
        'Ihr Team ist klein, aber Ihre Anforderungen sind es nicht: Erst NOURION Plus bringt Geräteverwaltung, erweiterte Sicherheit und proaktive Überwachung mit.'
      );
    }
    if (packageId === 'l' && seats > 5) {
      reasons.push(
        'Bei ' + seats + ' Arbeitsplätzen ist NOURION Plus wirtschaftlich der richtige Rahmen: Betreuung, Überwachung und Geräteverwaltung sind bereits einkalkuliert. Diskussionen über „Könnt ihr kurz vorbeikommen?“ entfallen.'
      );
    }
    if (packageId === 'xl') {
      reasons.push(
        'Ab ' + seats + ' Arbeitsplätzen wäre ein Paket von der Stange unseriös: Wir prüfen Ihre Umgebung in einem kurzen Audit und kalkulieren dann ehrlich anhand Ihrer Struktur.'
      );
    }
    if (workStyle === 'unterwegs') {
      reasons.push(
        'Ihre Geräte sind viel unterwegs: Mit der zentralen Geräteverwaltung bleiben Laptops und Handys überall aktuell, und lassen sich bei Verlust sofort sperren.'
      );
    } else if (workStyle === 'gemischt') {
      reasons.push(
        'Ihr Team arbeitet auch im Homeoffice: Die Geräteverwaltung sorgt dafür, dass jedes Gerät sicher eingerichtet ist, egal, wo gearbeitet wird.'
      );
    }
    if (dataSensitivity === 'sensibel') {
      reasons.push(
        'Sie arbeiten mit besonders geschützten Daten: Erweiterte Sicherheit und saubere Dokumentation sind hier keine Kür, sondern Pflicht.'
      );
    }
    if (downtimeImpact === 'teuer') {
      reasons.push(
        'Ausfälle kosten Sie schnell Geld: Mit proaktiver Überwachung erkennen wir Störungen, bevor daraus ein Stillstand wird.'
      );
    }
    if (downtimeImpact === 'kritisch') {
      reasons.push(
        'Ein Stillstand ist für Sie keine Option: Deshalb gehören Hochverfügbarkeit und erweiterte Bereitschaft in Ihre Planung.'
      );
    }

    // 4) Zusatzbausteine, die das Paket noch nicht abdeckt
    var addons = [];
    if (downtimeImpact === 'kritisch' && packageId !== 'xl') {
      addons.push({
        label: 'Erweiterte Notfallbereitschaft (Wochenende & Feiertage)',
        reason: 'Damit auch samstags jemand rangeht, wenn es brennt.'
      });
    }
    if (dataSensitivity === 'sensibel' && packageId !== 'xl') {
      addons.push({
        label: 'Compliance Dokumentation für Prüfungen',
        reason: 'Für Praxen, Kanzleien und Finanzdienstleister: Ihre IT dokumentiert, wie Behörden und Versicherer es erwarten.'
      });
    }

    return {
      packageId: packageId,
      reasons: reasons,
      addons: addons
    };
  }

  function labelFor(options, value) {
    for (var i = 0; i < options.length; i++) {
      if (options[i].value === value) return options[i].label;
    }
    return 'keine Angabe';
  }

  function buildAdvisorSummary(answers, result) {
    var pkg = PACKAGES[result.packageId];
    var workLabel = labelFor(WORK_STYLE_OPTIONS, answers.workStyle);
    var dataLabel = labelFor(DATA_OPTIONS, answers.dataSensitivity);
    var downLabel = labelFor(DOWNTIME_OPTIONS, answers.downtimeImpact);

    var lines = [
      'Ergebnis aus dem Bedarfscheck: ' + pkg.name + ' (' + pkg.sizeLabel + ')',
      'Arbeitsplätze: ' + answers.seats,
      'Arbeitsweise: ' + workLabel,
      'Daten: ' + dataLabel,
      'Ein Tag Ausfall wäre: ' + downLabel,
      'Bitte senden Sie mir ein unverbindliches Angebot.'
    ];
    if (result.addons.length > 0) {
      lines.push('Empfohlene Zusatzbausteine: ' + result.addons.map(function (a) { return a.label; }).join(', '));
    }
    return lines.join('\n');
  }

  // ── DOM Steuerung je Sektions Instanz ─────────────────────────────────────

  function initRoot(root) {
    if (root.dataset.nbcInit === '1') return;
    root.dataset.nbcInit = '1';

    var els = {
      progressGroup: root.querySelector('[data-nbc-progress-group]'),
      progressLabels: root.querySelectorAll('[data-nbc-step-btn]'),
      progressFill: root.querySelector('[data-nbc-progress-fill]'),
      stepsWrap: root.querySelector('[data-nbc-steps]'),
      stepPanels: root.querySelectorAll('[data-nbc-step-panel]'),
      nav: root.querySelector('[data-nbc-nav]'),
      navHint: root.querySelector('[data-nbc-nav-hint]'),
      backBtn: root.querySelector('[data-nbc-back]'),
      forwardBtn: root.querySelector('[data-nbc-forward]'),
      forwardLabel: root.querySelector('[data-nbc-forward-label]'),
      seatsInput: root.querySelector('[data-nbc-seats-input]'),
      seatsFigure: root.querySelector('[data-nbc-seats-figure]'),
      seatsLabel: root.querySelector('[data-nbc-seats-label]'),
      chips: root.querySelectorAll('[data-nbc-chip]'),
      choiceButtons: root.querySelectorAll('[data-nbc-choice-group]'),
      restartBtn: root.querySelector('[data-nbc-restart]'),
      cta: root.querySelector('[data-nbc-cta]'),
      resultTitle: root.querySelector('[data-nbc-result-title]'),
      resultPkgname: root.querySelector('[data-nbc-result-pkgname]'),
      resultSizelabel: root.querySelector('[data-nbc-result-sizelabel]'),
      resultTagline: root.querySelector('[data-nbc-result-tagline]'),
      resultPrice: root.querySelector('[data-nbc-result-price]'),
      resultReasons: root.querySelector('[data-nbc-result-reasons]'),
      resultAddonsWrap: root.querySelector('[data-nbc-result-addons-wrap]'),
      resultAddons: root.querySelector('[data-nbc-result-addons]'),
      resultAlternatives: root.querySelector('[data-nbc-result-alternatives]')
    };

    if (!els.stepsWrap || !els.stepPanels.length) return;

    var state = {
      step: 0,
      dir: 1,
      firstRender: true,
      answers: { seats: 8, workStyle: null, dataSensitivity: null, downtimeImpact: null }
    };
    var lastSummary = '';

    function canProceed() {
      switch (state.step) {
        case 0: return state.answers.seats >= 1;
        case 1: return state.answers.workStyle !== null;
        case 2: return state.answers.dataSensitivity !== null;
        case 3: return state.answers.downtimeImpact !== null;
        default: return false;
      }
    }

    function updateSeatsDisplay() {
      var seats = state.answers.seats;
      if (els.seatsFigure) {
        els.seatsFigure.innerHTML = seats >= 50
          ? (seats + '<span class="nbc-seats-plus">+</span>')
          : String(seats);
      }
      if (els.seatsLabel) {
        els.seatsLabel.textContent = seats === 1 ? 'Arbeitsplatz' : 'Arbeitsplätze';
      }
      if (els.seatsInput) {
        var progress = ((seats - 1) / 49) * 100;
        els.seatsInput.style.setProperty('--slider-progress', progress + '%');
        if (els.seatsInput.value !== String(seats)) els.seatsInput.value = String(seats);
        els.seatsInput.setAttribute('aria-label', 'Anzahl der Arbeitsplätze: ' + seats);
      }
      for (var i = 0; i < els.chips.length; i++) {
        var chip = els.chips[i];
        var n = parseInt(chip.getAttribute('data-nbc-chip'), 10);
        chip.classList.toggle('k-chip--active', n === seats);
      }
    }

    function updateChoiceCards() {
      for (var i = 0; i < els.choiceButtons.length; i++) {
        var btn = els.choiceButtons[i];
        var group = btn.getAttribute('data-nbc-choice-group');
        var value = btn.getAttribute('data-nbc-choice-value');
        var selected = state.answers[group] === value;
        btn.classList.toggle('k-choice--selected', selected);
        btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      }
    }

    function updateProgress() {
      for (var i = 0; i < els.progressLabels.length; i++) {
        var btn = els.progressLabels[i];
        var idx = parseInt(btn.getAttribute('data-nbc-step-btn'), 10);
        btn.classList.remove('is-current', 'is-done', 'is-future');
        if (idx === state.step) {
          btn.classList.add('is-current');
          btn.disabled = true;
          btn.setAttribute('aria-current', 'step');
        } else if (idx < state.step) {
          btn.classList.add('is-done');
          btn.disabled = false;
          btn.removeAttribute('aria-current');
        } else {
          btn.classList.add('is-future');
          btn.disabled = true;
          btn.removeAttribute('aria-current');
        }
      }
      if (els.progressFill) {
        var pct = (state.step / (STEP_LABEL_COUNT - 1)) * 100;
        els.progressFill.style.width = pct + '%';
      }
      if (els.progressGroup) {
        els.progressGroup.setAttribute('aria-label', 'Schritt ' + (state.step + 1) + ' von ' + STEP_LABEL_COUNT);
      }
    }

    function updateStepsVisibility() {
      els.stepsWrap.style.setProperty('--nbc-dir', String(state.dir));
      for (var i = 0; i < els.stepPanels.length; i++) {
        var panel = els.stepPanels[i];
        var idx = parseInt(panel.getAttribute('data-nbc-step-panel'), 10);
        if (idx === state.step) {
          panel.classList.remove('nbc-step--leaving');
          panel.hidden = false;
          panel.setAttribute('data-active', 'false');
          /* Doppeltes requestAnimationFrame: den Startzustand erst rendern
             lassen, dann in den Zielzustand wechseln, sonst greift der CSS
             Uebergang nicht (kein sichtbarer Sprung ohne diesen Trick). */
          (function (p) {
            window.requestAnimationFrame(function () {
              window.requestAnimationFrame(function () {
                p.setAttribute('data-active', 'true');
              });
            });
          })(panel);
        } else if (panel.getAttribute('data-active') === 'true') {
          panel.setAttribute('data-active', 'false');
          panel.classList.add('nbc-step--leaving');
          (function (p) {
            window.setTimeout(function () {
              p.hidden = true;
              p.classList.remove('nbc-step--leaving');
            }, 400);
          })(panel);
        } else {
          panel.hidden = true;
        }
      }
    }

    function updateNav() {
      if (!els.nav) return;
      els.nav.hidden = state.step === 4;
      if (els.backBtn) els.backBtn.disabled = state.step === 0;
      var proceed = canProceed();
      if (els.forwardBtn) {
        els.forwardBtn.disabled = !proceed;
        els.forwardBtn.classList.toggle('is-disabled', !proceed);
      }
      if (els.navHint) {
        els.navHint.hidden = proceed;
      }
      if (els.forwardLabel) {
        els.forwardLabel.textContent = state.step === 3 ? 'Ergebnis anzeigen' : 'Weiter';
      }
    }

    function renderResult() {
      var result = recommendPackage(state.answers);
      var pkg = PACKAGES[result.packageId];
      var seats = state.answers.seats;

      if (els.resultTitle) els.resultTitle.textContent = 'Für Ihre Angaben empfehlen wir ' + pkg.name;
      if (els.resultPkgname) els.resultPkgname.textContent = pkg.name;
      if (els.resultSizelabel) els.resultSizelabel.textContent = pkg.sizeLabel;
      if (els.resultTagline) els.resultTagline.textContent = pkg.tagline;

      if (els.resultPrice) {
        var seatWord = seats === 1 ? 'Arbeitsplatz' : 'Arbeitsplätze';
        var note = result.packageId === 'xl'
          ? 'Bei ' + seats + ' Arbeitsplätzen prüfen wir Ihre Umgebung in einem kurzen IT Audit und kalkulieren dann ehrlich.'
          : 'Ihr Angebot für ' + seats + ' ' + seatWord + ' erhalten Sie nach dem kostenlosen Erstgespräch. Monatlich kündbar.';
        els.resultPrice.innerHTML =
          '<p class="nrn-anfrage-tag">Auf Anfrage</p>' +
          '<p class="nbc-price-note">' + note + '</p>';
      }

      if (els.resultReasons) {
        els.resultReasons.innerHTML = '';
        for (var r = 0; r < result.reasons.length; r++) {
          var li = document.createElement('li');
          li.className = 'nbc-reason';
          li.innerHTML = CHECK_SVG + '<span>' + result.reasons[r] + '</span>';
          els.resultReasons.appendChild(li);
        }
      }

      if (els.resultAddonsWrap && els.resultAddons) {
        if (result.addons.length > 0) {
          els.resultAddonsWrap.hidden = false;
          els.resultAddons.innerHTML = '';
          for (var a = 0; a < result.addons.length; a++) {
            var addon = result.addons[a];
            var addonLi = document.createElement('li');
            addonLi.className = 'nbc-addon';
            addonLi.innerHTML = PLUS_SVG +
              '<span><span class="nbc-addon-label">' + addon.label + '</span>' +
              '<span class="nbc-addon-reason">' + addon.reason + '</span></span>';
            els.resultAddons.appendChild(addonLi);
          }
        } else {
          els.resultAddonsWrap.hidden = true;
          els.resultAddons.innerHTML = '';
        }
      }

      if (els.resultAlternatives) {
        els.resultAlternatives.innerHTML = '';
        for (var p = 0; p < PACKAGE_ORDER.length; p++) {
          var altId = PACKAGE_ORDER[p];
          if (altId === result.packageId) continue;
          var alt = PACKAGES[altId];
          var card = document.createElement('div');
          card.className = 'k-card nbc-alt-card';
          card.innerHTML =
            '<div class="nbc-alt-row">' +
              '<h5 class="nbc-alt-name">' + alt.name + '</h5>' +
            '</div>' +
            '<p class="nbc-alt-tagline">' + alt.tagline + '</p>';
          els.resultAlternatives.appendChild(card);
        }
      }

      lastSummary = buildAdvisorSummary(state.answers, result);
      if (els.cta) {
        els.cta.setAttribute('href', '/pages/kontakt-nourion?anfrage=' + encodeURIComponent(lastSummary));
      }
    }

    function render() {
      updateSeatsDisplay();
      updateChoiceCards();
      updateProgress();
      updateStepsVisibility();
      updateNav();
      if (state.step === 4) renderResult();
    }

    function scrollToHead() {
      if (state.firstRender) {
        state.firstRender = false;
        return;
      }
      var top = root.getBoundingClientRect().top + window.scrollY - 90;
      var reduziert = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: top, behavior: reduziert ? 'auto' : 'smooth' });
    }

    function goTo(target) {
      if (target < 0 || target > 4 || target === state.step) return;
      state.dir = target > state.step ? 1 : -1;
      state.step = target;
      render();
      scrollToHead();
    }

    // Seats Slider
    if (els.seatsInput) {
      els.seatsInput.addEventListener('input', function () {
        var v = parseInt(els.seatsInput.value, 10);
        state.answers.seats = isNaN(v) ? 1 : v;
        updateSeatsDisplay();
        updateNav();
      });
    }

    // Schnellwahl Chips
    for (var c = 0; c < els.chips.length; c++) {
      els.chips[c].addEventListener('click', function () {
        var n = parseInt(this.getAttribute('data-nbc-chip'), 10);
        state.answers.seats = n;
        updateSeatsDisplay();
        updateNav();
      });
    }

    // Auswahlkarten (Schritt 1 bis 3)
    for (var b = 0; b < els.choiceButtons.length; b++) {
      els.choiceButtons[b].addEventListener('click', function () {
        var group = this.getAttribute('data-nbc-choice-group');
        var value = this.getAttribute('data-nbc-choice-value');
        state.answers[group] = value;
        updateChoiceCards();
        updateNav();
      });
    }

    // Fortschritts Labels, nur bereits durchlaufene Schritte klickbar
    for (var pIdx = 0; pIdx < els.progressLabels.length; pIdx++) {
      els.progressLabels[pIdx].addEventListener('click', function () {
        var idx = parseInt(this.getAttribute('data-nbc-step-btn'), 10);
        if (idx < state.step) goTo(idx);
      });
    }

    if (els.backBtn) {
      els.backBtn.addEventListener('click', function () {
        if (state.step > 0) goTo(state.step - 1);
      });
    }
    if (els.forwardBtn) {
      els.forwardBtn.addEventListener('click', function () {
        if (canProceed()) goTo(state.step + 1);
      });
    }
    if (els.restartBtn) {
      els.restartBtn.addEventListener('click', function () {
        // Nur die Anzeige springt zurueck, die Antworten bleiben erhalten
        goTo(0);
      });
    }
    if (els.cta) {
      els.cta.addEventListener('click', function () {
        try {
          window.sessionStorage.setItem('nourion-anfrage', lastSummary);
        } catch (e) {
          // Speicher evtl. gesperrt (privates Fenster), Navigation per href
          // funktioniert trotzdem, das Kontaktformular bekommt den Text
          // dann ueber den ?anfrage= Parameter.
        }
      });
    }

    render();
    // Der Mount konsumiert den Erst-Render-Marker: die erste echte
    // Schrittnavigation soll bereits zum Kopf scrollen.
    state.firstRender = false;
  }

  function initAll(context) {
    var scope = context && context.querySelectorAll ? context : document;
    var roots = scope.querySelectorAll('[data-nbc-root]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    if (scope.matches && scope.matches('[data-nbc-root]')) initRoot(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
